import { render, staticRenderFns } from "./recipe.vue?vue&type=template&id=16338bbc&"
import script from "./recipe.vue?vue&type=script&lang=js&"
export * from "./recipe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/arthur.cruz/BRNDWGN/Projects/mz-marketing-wp/web/app/themes/mz-marketing/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('16338bbc')) {
      api.createRecord('16338bbc', component.options)
    } else {
      api.reload('16338bbc', component.options)
    }
    module.hot.accept("./recipe.vue?vue&type=template&id=16338bbc&", function () {
      api.rerender('16338bbc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/scripts/vue/recipe.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/recipe.vue
// module id = 89
// module chunks = 0